import { useEffect } from "react";
import { useLocation } from "react-router-dom";


const mobileWifiUrl = process.env.REACT_APP_MOBILE_WIFI_URL;
const onlinestoreUrl = process.env.REACT_APP_ONLINESTORE_URL;


const toHome = [
  "/e-commerce-epp",
  "/shop",
  "/checkout",
  "/my-account",
  "/blockchain",
  "/home",
   "/adx",
  "/xox-city",
  "/sports",
  "/black-app-survey",
  "/campaign-pdf",
  "/alliance-bank-xox-campaign",
  "/xox-black-app-x-foodpanda-2023",
  "/black-market-merchant-refer-and-reward",
  "/10561-2",
  "/whatsapp-tnc",
  "/10784-2"
]

const toCareerList = [
  "/join-our-industrial-training",
  "/application-form",
  "/internship-application-form",
  "/be-future-leaders-in-xox" ,
  "/join-our-professional-team",
  "/management-trainee",
  "/internship-2",
  "/leader",
]


const redirects = {
  "/prepaid-onebox": `${mobileWifiUrl}/prepaid/onex5g`,
  "/onexox-black" : `${mobileWifiUrl}/postpaid/postpaid5g`,
  "/esim" : `${onlinestoreUrl}/onexox-esim`,
  "/volte" : `${onlinestoreUrl}/onexox-volte`,
  "/black-apps" : `${onlinestoreUrl}/xox-app`,
  "/contact-us" : "/contactus",
  "/telecommunications" : `${mobileWifiUrl}`,
  "/space-x" : "/spacedx",
  "/terms-conditions" : "/terms-condition" ,
  "/terms-conditions/" : "/terms-condition" ,
  "/privacyStatement/details/": "/privacystatement",
  "/new-career" : "/careers",
  "/investor-relations" : "/investorrelations",
  "/investor-relations-agm" : "/investorrelations",
  "/scam-alert" : '/scamalert',
  "/fintech" : "https://www.xoxwallet.com/",
  // "/notifications" : `${onlinestoreUrl}/notifications`
  
};

toHome.forEach(path => redirects[path] = "/");
toCareerList.forEach(path => redirects[path] = "/careerlist");

export default function RedirectHub() {
  const { pathname } = useLocation();

  useEffect(() => {
    if (redirects[pathname]) {
      window.location.href = redirects[pathname];
    }
  }, [pathname]);

  return null; 
}